import { useTranslation } from 'react-i18next'
import { imageUrl } from 'app/frontend/base/helpers'
import { RaidPlanAssignmentType } from 'app/frontend/types/custom/RaidPlan'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import {
  getEffectiveAssignmentType,
  isImmunityAssignmentType,
  isInterruptAssignmentType,
} from './assignmentTimeline'

type Props = {
  assignmentType?: RaidPlanAssignmentType
}

const ASSIGNMENT_TYPE_LABEL_KEY: Record<
  Exclude<RaidPlanAssignmentType, 'general' | 'general_assignment'>,
  string
> = {
  immunity: 'immunity',
  mobile_immunity: 'mobile-immunity',
  interrupt: 'interrupt',
  ranged_interrupt: 'ranged-interrupt',
  melee_interrupt: 'melee-interrupt',
}

const AssignmentTypeIcon = ({ assignmentType }: Props) => {
  const { t } = useTranslation()
  const effectiveType = getEffectiveAssignmentType(assignmentType)
  const isInterrupt = isInterruptAssignmentType(effectiveType)
  const isImmunity = isImmunityAssignmentType(effectiveType)
  if (!isInterrupt && !isImmunity) return null
  const label = t(
    `dashboard.team.plans.assignments.assignment-types.${ASSIGNMENT_TYPE_LABEL_KEY[effectiveType]}`,
  )

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        {isImmunity ? (
          <img
            src={imageUrl('icons/642.jpg')}
            alt={label}
            className='w-5 h-5 shrink-0 rounded-full border border-border object-cover'
          />
        ) : (
          <img
            src={imageUrl('ej-icons/interrupt_icon.png')}
            alt={label}
            className='w-5 h-5 shrink-0'
          />
        )}
      </TooltipTrigger>
      <TooltipContent className='text-sm pointer-events-none'>
        {label}
      </TooltipContent>
    </Tooltip>
  )
}

export default AssignmentTypeIcon
